define('views/modules/setting/business/blocks/brand/brand',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // models
    'models/member/group',
    // views
    'views/parts/info-section',
    'views/modules/setting/business/blocks/brand/brand-edit-panel',
    // templates
    'text!templates/modules/setting/business/blocks/brand/brand.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // models
    MGroup,
    // views
    VInfoSection,
    VBrandEditPanel,
    // templates
    TBrand
) {

    var VBrand = Backbone.Epoxy.View.extend({
        template: TBrand,

        regions: {
            colorpicker: ".color-picker-container",
            text: ".brand-text",
            type: ".brand-type"
        },

        initialize: function(opt) {

            this.options = opt || {};

            _.extend(this, {
                group: opt.group
            });

            this.view = {
                info: new VInfoSection({
                    title: "Your brand",
                    icon: "sl-icon-magic-wand",
                    //help: "messages:helpbox-business-brand-view",
                    buttonBottom: {
                        text: "Customize your brand",
                        context: this,
                        callback: this.onEditBrand
                    },
                    content: this.template,
                }),

            };

        },

        render: function() {
            // this.resetModel();

            var view = this.view,
                html = Mustache.render(this.template, Mustache.getContext(this.group.toJSON()));

            this.assign(view.info, this.$el) // must be first
                .generateZones();

            view.info.setContent(html);

            this.applyBindings();

            return this;
        },

        // Deprecated function because we use this.group passed in option when initialise
        resetModel: function() {
            this.model.reset(User.getMainGroup());
        },

        /////////////
        // actions //
        /////////////

        onEditBrand: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = null;

            if (!view.edit) {
                panel = view.edit = new VBrandEditPanel({ model: this.group, });

                this.listenTo(view.edit, 'brand:save', this.onSaveBrand);
            } else {
                panel = view.edit;
            }

            this.trigger('panel:stack', panel);
        },

        onSaveBrand: function(e) {
            this.render();
        }

    });

    return VBrand;
});

